import React from "react";
import { useAuth } from "../../context/AuthContext";

const Navbar = ({ isOpen, toggleSidebar }) => {
  const { user, logout } = useAuth();

  return (
    <nav
      className="navbar navbar-expand bg-white border-bottom shadow-sm px-3"
      style={{
        position: "fixed",
        top: 0,
        left: isOpen ? "250px" : "70px",
        right: 0,
        height: "64px",
        zIndex: 999,
        transition: "left 0.3s ease",
      }}
    >
      {/* Toggle Button */}
      <button className="btn btn-light btn-sm me-3" onClick={toggleSidebar}>
        <i
          className={`bi ${isOpen ? "bi-layout-sidebar" : "bi-layout-sidebar-reverse"} fs-5`}
        ></i>
      </button>

      {/* Page Title */}
      <span className="fw-semibold text-dark">Admin Panel</span>

      {/* Right side */}
      <div className="ms-auto d-flex align-items-center gap-3">
        {/* Notifications */}
        <button className="btn btn-light btn-sm position-relative">
          <i className="bi bi-bell fs-5"></i>
          <span
            className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger"
            style={{ fontSize: "9px" }}
          >
            3
          </span>
        </button>

        {/* User Dropdown */}
        <div className="dropdown">
          <button
            className="btn btn-light btn-sm dropdown-toggle d-flex align-items-center gap-2"
            data-bs-toggle="dropdown"
          >
            <div
              className="rounded-circle d-flex align-items-center justify-content-center text-white"
              style={{
                width: 32,
                height: 32,
                background: "linear-gradient(135deg, #1a3c5e, #2d6a4f)",
                fontSize: "13px",
                fontWeight: 600,
              }}
            >
              {user?.name?.charAt(0).toUpperCase()}
            </div>
            <span className="d-none d-md-inline small fw-medium">
              {user?.name}
            </span>
          </button>
          <ul className="dropdown-menu dropdown-menu-end shadow border-0">
            <li>
              <div className="dropdown-item-text py-2">
                <div className="fw-semibold small">{user?.name}</div>
                <div className="text-muted" style={{ fontSize: "12px" }}>
                  {user?.role}
                </div>
              </div>
            </li>
            <li>
              <hr className="dropdown-divider my-1" />
            </li>
            <li>
              <button className="dropdown-item small" onClick={logout}>
                <i className="bi bi-box-arrow-left me-2 text-danger"></i>Logout
              </button>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
